export default __webpack_public_path__ + "static/media/bannerTransito.336b86f2.jpg";